module.exports = __webpack_public_path__ + "img/clock-white.993591b9.svg";